import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedGroupForm from './MedGroupForm';

const EditMedGroupModal = ({ show, onHide, medgrpvalue, edittrigger, onCallParent }) => {
    const isEdit = Boolean(medgrpvalue && (medgrpvalue.group_id || medgrpvalue.med_group_id || medgrpvalue.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Med Group' : 'Add Med Group'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedGroupForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medgrpvalue={medgrpvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

EditMedGroupModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medgrpvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditMedGroupModal;
